// Simple Custom Tools Loader
if (window.location.pathname.includes('/account/custom-tools')) {
  const loadingMessage = window.customToolsLoadingMessage || 'Loading...';
  
  const loadingHTML = `
     <div id="custom-tools-loader" style="
       position: fixed;
       top: 0;
       left: 0;
       width: 100%;
       height: 100%;
       background: white;
       display: flex;
       align-items: center;
       justify-content: center;
       z-index: 9999;
     ">
       <style>
        .custom-tools__loader-title {
            font-size: 24px;
            line-height: 32px;
            color: #111827;
            margin: 0;
            font-family: Metropolis;
        }
        @media (min-width: 768px) {
            #custom-tools-loader {
                align-items: flex-start !important;
                padding-top: 200px !important;
            }
            .custom-tools__loader-title {
                font-size: 34px;
                line-height: 40px;
                color: #111827;
                margin: 0;
                font-family: Metropolis;
            }
        }
       </style>
      <div style="text-align: center;">
        <div style="
          width: 48px;
          height: 48px;
          margin: 0 auto 24px;
          position: relative;
        ">
          <div style="
            width: 100%;
            height: 100%;
            border: 3px solid #E5E7EB;
            border-radius: 50%;
            position: absolute;
            top: 0;
            left: 0;
          "> </div>
          <div style="
            width: 100%;
            height: 100%;
            border: 3px solid transparent;
            border-top: 3px solid #374151;
            border-radius: 50%;
            position: absolute;
            top: 0;
            left: 0;
            animation: spin 1.2s linear infinite;
          "> </div>
        </div>
        <h2 class="fw-700 custom-tools__loader-title">${loadingMessage}</h2>
      </div>
    </div>
    <style>
      @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
      }
    </style>
  `;
  
  document.body.insertAdjacentHTML('beforeend', loadingHTML);
  
  window.addEventListener('load', function() {
    setTimeout(function() {
      const loader = document.getElementById('custom-tools-loader');
      if (loader) {
        loader.remove();
      }
    }, 3000); // 2 second delay after page load
  });
}
